import { ConfigProvider, Input } from 'antd';


const MyInput = (props) => {
    const { icon, onChange = ()=>{}, ...rest } = props;
    // console.log(rest, " = ressstttt");
    const handleChange = (e) => {
        // console.log(e);
        onChange(e);
    }
  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            // activeBorderColor: PRIMARY_ORANGE_COLOR,
            // hoverBorderColor: PRIMARY_ORANGE_COLOR,
          },
        },
      }}
    >
        <Input 
          size="large" 
          placeholder="Enter text here" 
          style={{ borderRadius: '16px' }}
          // prefix={<UserOutlined />}
          suffix={icon}
          // value={value}
          onChange={handleChange}
          {...rest} 
        />
    </ConfigProvider>
  )
}

export default MyInput